import { css, styled } from 'css-literal-loader/styled';
import classNames from 'classnames';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import defaultProps from 'recompose/defaultProps';
import withProps from 'recompose/withProps';
import Layout from '@4c/layout';

import madeForApple from '../assets/made-for-apple.png';
import madeForApple2x from '../assets/made-for-apple@2x.png';
import madeForApple3x from '../assets/made-for-apple@3x.png';
import probeImg from '../assets/probe.png';
import srcSet from '../utils/srcSet';
import BreadCrumbs from './BreadCrumbs';
import Button from './Button';
import FormattedPrice from './FormattedPrice';
import Heading from './Heading';
import PageSegment from './PageSegment';

export const MARGIN = 30;

const styles = require('./ProbeImageSegment-styles.module.scss');

function ProbeImageSegmentPrice({ price, perMonth, perYear, noCents }) {
  return (
    <FormattedPrice
      value={price}
      perMonth={perMonth}
      perYear={perYear}
      noCents={noCents}
    />
  );
}

function ProbeImageSegmentLicensedUsers() {
  return (
    <FormattedMessage
      id="probeImageSegment.licensedUsers.name"
      defaultMessage="Licensed Users"
    />
  );
}

function ProbeImageSegmentDeviceLightningName({ className }) {
  return (
    <span className={classNames(className)}>
      <FormattedMessage
        id="probeImageSegment.deviceLightning.name"
        defaultMessage="Butterfly iQ (Lightning)"
      />
    </span>
  );
}

function ProbeImageSegmentDeviceUsbcName({ className }) {
  return (
    <span className={classNames(className)}>
      <FormattedMessage
        id="probeImageSegment.deviceUsbc.name"
        defaultMessage="Butterfly iQ (USB-C)"
      />
    </span>
  );
}

const ProbeImageSegmentHeading = withProps({ level: '2' })(
  styled(Heading, null, "ProbeImageSegmentHeading", require("./ProbeImageSegment-ProbeImageSegmentHeading.module.scss"), "probe-image-segment-heading", "probeImageSegmentHeading"),
);

const ProbeImageSegmentSection = defaultProps({ display: 'block' })(
  styled(Layout, null, "ProbeImageSegmentSection", require("./ProbeImageSegment-ProbeImageSegmentSection.module.scss"), "probe-image-segment-section", "probeImageSegmentSection"),
);

const ProbeImageSegmentParagraph = styled('p', null, "ProbeImageSegmentParagraph", require("./ProbeImageSegment-ProbeImageSegmentParagraph.module.scss"), "probe-image-segment-paragraph", "probeImageSegmentParagraph");

function ProbeImageSegment({ showImage, children, intl, title }) {
  return (
    <PageSegment theme="dark">
      <BreadCrumbs active="configure" title={title} />
      <div className={styles.segment}>
        {showImage && (
          <div className={styles.img}>
            <img
              src={probeImg}
              alt={intl.formatMessage({
                id: 'probeSegmet.probe.alt',
                defaultMessage: 'A Butterfly iQ probe',
              })}
            />
          </div>
        )}
        <PageSegment.Content className={styles.content}>
          {children}
        </PageSegment.Content>
      </div>
    </PageSegment>
  );
}

function ProbeImageSegmentMadeForIPhoneIPadBadge() {
  return (
    <img
      src={madeForApple}
      srcSet={srcSet(madeForApple, madeForApple2x, madeForApple3x)}
      alt="Made for iPhone and iPad"
    />
  );
}

const BUTTON_MIN_WIDTH = 210;

const ProbeImageSegmentButton = styled(Button, null, "ProbeImageSegmentButton", require("./ProbeImageSegment-ProbeImageSegmentButton.module.scss"), "probe-image-segment-button", "probeImageSegmentButton");

const IntlProbeImageSegment = injectIntl(ProbeImageSegment);

IntlProbeImageSegment.BUTTON_MIN_WIDTH = BUTTON_MIN_WIDTH;

IntlProbeImageSegment.Button = ProbeImageSegmentButton;
IntlProbeImageSegment.Price = ProbeImageSegmentPrice;
IntlProbeImageSegment.Heading = ProbeImageSegmentHeading;
IntlProbeImageSegment.Section = ProbeImageSegmentSection;
IntlProbeImageSegment.Paragraph = ProbeImageSegmentParagraph;
IntlProbeImageSegment.DeviceLightningName = ProbeImageSegmentDeviceLightningName;
IntlProbeImageSegment.DeviceUsbcName = ProbeImageSegmentDeviceUsbcName;
IntlProbeImageSegment.LicensedUsers = ProbeImageSegmentLicensedUsers;
IntlProbeImageSegment.MadeForIPhoneIPadBadge = ProbeImageSegmentMadeForIPhoneIPadBadge;

export default IntlProbeImageSegment;
